<template>
  <el-select v-model="user_id" :clearable="true" class="form-control" placeholder="Selectionnez un commercial">
    <el-option
      v-for="user in users"
      :key="user.id"
      :label="user.name"
      :value="user.id">
    </el-option>
  </el-select>
</template>

<script>
  export default {
    name: 'user-select',
    props: ['id'],
    data () {
      return {
        user_id: this.id,
        ignoreNextChange : false
      }
    },
    watch: {
      id (value) {
        this.ignoreNextChange = true
        this.user_id = value
      },
      user_id (value) {
        if (value === '') {
          value = null
        }

        if(!this.ignoreNextChange) {
          this.$emit('change', value)
        }
        this.ignoreNextChange = false
      }
    },
    computed: {
      users () {
        return this.$store.getters['users/all']
      }
    }
  }
</script>



// WEBPACK FOOTER //
// UserSelect.vue?93cbecf0